import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { API_URL } from '../config/api'
import './Services.css'

function Services() {
  const [services, setServices] = useState([])
  const [loading, setLoading] = useState(true)
  const [expandedId, setExpandedId] = useState(null)

  const getDescriptionText = (desc) => {
    if (typeof desc === 'string') return desc
    if (Array.isArray(desc)) {
      return desc
        .map(block => block.children?.map(child => child.text).join('') || '')
        .join('\n')
    }
    return ''
  }

  const getImageUrl = (image) => {
    if (!image) return null
    if (Array.isArray(image.data)) {
      return image.data[0]?.attributes?.url
    }
    return image.data?.attributes?.url || image.url
  }

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${API_URL}/api/services?populate=*`)
        const data = await response.json()
        const servicesData = (data.data || [])
          .map(item => ({
            id: item.id,
            ...item.attributes
          }))
          .sort((a, b) => a.id - b.id) // Sort by ID ascending
        setServices(servicesData)
      } catch (error) {
        console.error('Error fetching services:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchServices()
  }, [])

  return (
    <section className="features">
      <h2>Onze Diensten</h2>

      {loading ? (
        <div className="loading">Diensten worden geladen...</div>
      ) : services.length === 0 ? (
        <div className="no-services">
          <p>Nog geen diensten beschikbaar.</p>
        </div>
      ) : (
        <div className="features-grid">
          {services.map((service) => (
            <div
              key={service.id}
              className={`feature-card ${expandedId === service.id ? 'expanded' : ''}`}
              onClick={() => setExpandedId(expandedId === service.id ? null : service.id)}
            >
              {service.image && getImageUrl(service.image) && (
                <div className="service-image-wrapper">
                  <img
                    src={`${API_URL}${getImageUrl(service.image)}`}
                    alt={service.title}
                    className="service-image"
                  />
                </div>
              )}
              <div className="service-content">
                <h3>{service.title}</h3>
                <p className={`service-description ${expandedId === service.id ? 'expanded' : ''}`}>
                  {getDescriptionText(service.description)}
                </p>
                <Link
                  to={`/contact?service=${encodeURIComponent(service.title)}`}
                  className="service-cta-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  Vraag prijs aan
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

export default Services
